import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-hosting',
  templateUrl: './cloud-hosting.component.html',
  styleUrls: ['./cloud-hosting.component.css']
})
export class CloudHostingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
